
<script>
/**
 * This mixin need the `LanguageSelect.vue` and the `Display.vue` component in the platform
 *
 * For the LanguageSelect the ref `languageSelect` is assumed otherwise set the data-attribute `languageSelectRefName`
 * For the Screenshot LanguageSelect the ref `screenshotLanguageSelect` is assumed otherwise set the data-attribute `screenshotLanguageSelectRefName`
 *
 * For the Display the ref `display` is assumed otherwise set the data-attribute `displayRefName`
 *
 * If a screenshotLanguageSelect is available the saveScreenshot() method switches the language to the selected language before taking a screenshot.
 */

import JSZip from 'jszip';

import { startDownload } from '@/utils';
import state from '@/state';

function getOpt(ctx, options, attr, fallback) {
  if (options && options[attr] != null) {
    return options[attr];
  }
  if (ctx && ctx[attr] != null) {
    return ctx[attr];
  }
  return fallback;
}

export default {
  data: () => ({
  }),

  destroyed() {
  },

  methods: {
    saveScreenshot(options) {
      const displayRefName = getOpt(this, options, 'displayRefName', 'display');
      const displayRef = this.$refs[displayRefName];
      const languageSelectRefName = getOpt(this, options, 'languageSelectRefName', 'languageSelect');
      const languageSelectRef = this.$refs[languageSelectRefName];
      const screenshotLanguageSelectRefName = getOpt(this, options, 'screenshotLanguageSelectRefName', 'screenshotLanguageSelect');
      const screenshotLanguageSelectRef = this.$refs[screenshotLanguageSelectRefName];
      const drawBorderAroundScreenshot = getOpt(this, options, 'drawBorderAroundScreenshot', false);
      const screenshotPrefix = getOpt(this, options, 'screenshotPrefix', false);

      let origLanguage = null;
      state.runAsync(async () => {
        if (languageSelectRef && screenshotLanguageSelectRef) {
          origLanguage = languageSelectRef.language;
          languageSelectRef.language = screenshotLanguageSelectRef.language;
          await new Promise(resolve => setTimeout(resolve, 2000));
        }
        const buffer = await displayRef.generateScreenshot(drawBorderAroundScreenshot);
        let fileName = `Screenshots-${Date.now()}`;
        if (screenshotPrefix && screenshotPrefix !== '') {
          fileName = `${screenshotPrefix}-${fileName}`;
        }
        if (origLanguage != null) {
          languageSelectRef.language = origLanguage;
        }
        startDownload(`${fileName}.png`, 'image/png', buffer);
      });
    },

    saveScreenshots(options) {
      const displayRefName = getOpt(this, options, 'displayRefName', 'display');
      const displayRef = this.$refs[displayRefName];
      const languageSelectRefName = getOpt(this, options, 'languageSelectRefName', 'languageSelect');
      const languageSelectRef = this.$refs[languageSelectRefName];
      const drawBorderAroundScreenshot = getOpt(this, options, 'drawBorderAroundScreenshot', false);
      const screenshotPrefix = getOpt(this, options, 'screenshotPrefix', false);
      const languages = getOpt(this, options, 'languages', []);
      const userFileName = prompt("Bitte einen Namen für den Screenshot eingeben:");
      if (!userFileName) {
        throw new Error('No file name provided');
      }
      state.runAsync(async () => {
        const origLanguage = languageSelectRef.language;

        const zip = new JSZip();

        for (const lang of languages) {
          languageSelectRef.language = lang.value;
          await new Promise(resolve => setTimeout(resolve, 2000));
          const buffer = await displayRef.generateScreenshot(drawBorderAroundScreenshot);

          const folderName = lang.short || lang.text;
          zip.folder(folderName);
          let fileName = userFileName;
          if (screenshotPrefix && screenshotPrefix !== '') {
            fileName = `${screenshotPrefix}_${fileName}`;
          }
          zip.file(`${folderName}/${fileName}.png`, buffer);
        }

        languageSelectRef.language = origLanguage;
        await new Promise(resolve => setTimeout(resolve, 2000));

        let fileName = `Screenshots-${userFileName}-${Date.now()}`;
        if (screenshotPrefix && screenshotPrefix !== '') {
          fileName = `${screenshotPrefix}-${fileName}`;
        }
        const buffer = await zip.generateAsync({ type: 'nodebuffer' });
        startDownload(`${fileName}.zip`, 'application/zip', buffer);
      });
    },
  },
};
</script>
